import styled from 'styled-components';
import { motion } from 'framer-motion';

const PanelOverlay = styled.div`
  z-index: ${(props) => (props.panelOverlay ? "900" : "10001")};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
`;

const PanelWrapper = styled(motion.div)`
  position: absolute;
  height: 100vh;
  right: 0;
  z-index: 10002;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  @media (min-width: 769px) {
    width: ${props => props.maxWidth};
  }
`;

const PanelHeader = styled.div`
  background-color: ${props => (props.white ? '#fff' : '#2d1441')};
  padding: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: '#2d1441';
`;

const PanelTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  img {
    padding: 10px;
    flex-grow: 1;
    max-height: 50px;
  }
  div:nth-child(2) {
    flex-grow: 2;
  }
`;

const PanelClose = styled.div`
  text-align: right;
  padding: 5px;
  border: 0;
  cursor: pointer;
  background-color: '#2d1441';
`;

const PanelBody = styled.div`
  background: ${props => props.backgroundColor};
  overflow-x: hidden;
  overscroll-behavior: contain;
  height: 100%;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgb(209, 209, 209);
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(45, 21, 64, 0.459);
    border-radius: 8px;
  }
`;

const duration = 0.2;
const PanelTransitions = {
  initial: {
    opacity: 1,
    x: 500,
  },
  initialMobile: {
    opacity: 1,
    y: 500,
  },
  enter: {
    opacity: 1,
    x: 0,
    transition: {
      duration,
    },
  },
  enterMobile: {
    opacity: 1,
    y: 0,
    transition: {
      duration,
    },
  },
  exit: {
    opacity: 1,
    x: 500,
    transition: {
      duration,
    },
  },
  exitMobile: {
    opacity: 1,
    y: 500,
    transition: {
      duration,
    },
  },
};

export {
  PanelOverlay,
  PanelWrapper,
  PanelClose,
  PanelBody,
  PanelTransitions,
  PanelHeader,
  PanelTitle,
};
